import { GetOnePeriodicCheckInDto, GetLastPeriodicCheckOutDto } from '../../../types/periodic-check.dto'

export const GET_LAST_PERIODIC_CHECK = 'GET_LAST_PERIODIC_CHECK'
export const GET_LAST_PERIODIC_CHECK_SUCCESS = 'GET_LAST_PERIODIC_CHECK_SUCCESS'
export const GET_LAST_PERIODIC_CHECK_ERROR = 'GET_LAST_PERIODIC_CHECK_ERROR'
export const RESET_GET_LAST_PERIODIC_CHECK = 'RESET_GET_LAST_PERIODIC_CHECK'

export interface GetLastPeriodicCheck {
  type: typeof GET_LAST_PERIODIC_CHECK
  payload: GetLastPeriodicCheckOutDto
}

export interface GetLastPeriodicCheckSuccess {
  type: typeof GET_LAST_PERIODIC_CHECK_SUCCESS
  payload: GetOnePeriodicCheckInDto<any>
}

export interface GetLastPeriodicCheckError {
  type: typeof GET_LAST_PERIODIC_CHECK_ERROR
  payload: string | boolean
}

export interface ResetGetLastPeriodicCheck {
  type: typeof RESET_GET_LAST_PERIODIC_CHECK
  payload: null
}

export interface State {
  data: GetOnePeriodicCheckInDto<any> | null
  states: {
    loading: boolean
    success: boolean
    error: boolean | string
  }
}

export const initialState: State = {
  data: null,
  states: {
    loading: false,
    success: false,
    error: false,
  },
}

export type Actions = GetLastPeriodicCheck | GetLastPeriodicCheckSuccess | GetLastPeriodicCheckError | ResetGetLastPeriodicCheck
